/* 本控件用于多复选框，
 * @Author: eric.liu
 * @Date: 2017-03-31 15:36:23
 * @Last Modified by: eric.liu
 * @Last Modified time: 2017-05-05 17:15:24
 */
<template>
    <div>
        <div class="input-group">
            <span class="input-group-addon"
                  v-if="label&&label.length>0"><span class="gray">{{label}}</span></span>
            <div class="fg-line">
                <template v-for="(item,index) in source">
                    <c-checkbox v-model="myvalue" :key="index"
                                v-bind:is-enabled="isEnabled"
                                v-bind:dvalue="item[svalue]"
                                v-bind:label="item[stext]"></c-checkbox>&nbsp;
                </template>

            </div>
        </div>
    </div>
</template>

<script>
import vue from 'vue';
import './checkbox';
export default {
    name: 'c-checkboxgroup',
    data() {
        return {
            myvalue: []
        };
    },
    props: {
        value: {
            required: true,
            default: function () {
                return [];
            }
        },
        label: {},
        source: {
            required: true,
            default: function () {
                return [];
            }
        },
        svalue: {
            default: function () {
                return 'value';
            }
        },
        stext: {
            default: function () {
                return 'text';
            }
        },
        /**
         *是否为互斥，互斥将返回单值
         */
        isMutual: {
            default: true
        },
        isEnabled: {
            default: true
        }
    },
    mounted(){
        var vm = this;
        if(vm.isMutual){
            vm.myvalue.length=0;
            vm.myvalue.push(vm.value);
        }else{
            if(vm.value instanceof Array)
                vm.myvalue = vm.value;
            else{
                vm.myvalue.length=0;
                vm.myvalue.push(vm.value);
            }
        }
    },
    watch: {
        'value': function () {
            var vm = this;
            if(vm.isMutual){
                vm.myvalue.length=0;
                vm.myvalue.push(vm.value);
            }else{
                if(vm.value instanceof Array)
                    vm.myvalue = vm.value;
                else{
                    vm.myvalue.length=0;
                    vm.myvalue[0]=vm.value;
                }
            }

        },
        'myvalue': function () {
            var vm = this;
            var resultval=null;
            if (vm.isMutual) {
                if(vm.myvalue.length!==0){
                    resultval=vm.myvalue[vm.myvalue.length-1];
                    vm.myvalue.length=0;
                    vm.myvalue[0]=resultval;
                }

            }else{
                resultval=vm.myvalue;
            }
            if(vm.value!==resultval)
                vm.$emit('input', resultval);
        }
    }
};
</script>



// WEBPACK FOOTER //
// checkboxgroup.vue?f7b073d6